import { useNavigate, useParams } from "react-router-dom";
import { Button, SectionTitle } from "@porchpass/ui";
import DashboardLayout from "src/layouts/DashboardLayout";

export default () => {
  const { dealerName } = useParams();
  const navigate = useNavigate();
  return (
    <DashboardLayout pageTitle="Unauthorized">
      <div className="flex flex-col items-center gap-[18px]">
        <SectionTitle title="Sorry!" size="md" />
        <p className="text-base leading-[22.4px] text-[#111827]">
          You do not have permission to go to that page
        </p>
        <Button
          type="button"
          variant="primary"
          size="l"
          className="w-full max-w-[246px]"
          onClick={() => navigate(`/${dealerName}`)}
        >
          Navigate Home
        </Button>
      </div>
    </DashboardLayout>
  );
};
